import { render, staticRenderFns } from "./VentasClienteOnline.vue?vue&type=template&id=180708f7&scoped=true&"
import script from "./VentasClienteOnline.vue?vue&type=script&lang=js&"
export * from "./VentasClienteOnline.vue?vue&type=script&lang=js&"
import style0 from "./VentasClienteOnline.vue?vue&type=style&index=0&id=180708f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180708f7",
  null
  
)

export default component.exports